import { useState } from "react";
import { UPDATE_STATUS } from "./query";
import useGlobalMutation from "../../hooks/useGlobalMutation";
import { clearCache } from "../../utils";
import { Loader } from "../shared";

const PublishStatus = ({ id, publishStatus }) => {
    const [status, setStatus] = useState(publishStatus);

    const { submitMutation, loading } = useGlobalMutation(UPDATE_STATUS, (cache) => {
        clearCache(cache, "allAbbvieProEmbedJsSnippets");
    });

    const updateStatusHandler = async () => {
        const variables = {
            embedJsSnippet: { configStatus: !status, embedId: id },
        };

        const isResultNull = await submitMutation(
            variables,
            "updateStatusAbbvieProEmbedJsSnippet",
            "Status updated"
        );
        isResultNull === null && setStatus(!status);
    };

    return (
        <>
            {loading && <Loader />}
            <div className="p-3">
                <div className="row justify-content-center">
                    <div className="col-auto d-flex flex-column align-items-center">
                        <h5 className="mb-4">
                            Current Status:{" "}
                            <span className={status ? "text-success" : "text-danger"}>
                                {status ? "Published" : "Unpublished"}
                            </span>
                        </h5>
                        <button
                            type="button"
                            className={` rounded m-0 d-flex align-items-center ${
                                !status ? "btn btn-success" : "btn btn-danger"
                            }`}
                            onClick={updateStatusHandler}
                        >
                            {!status ? (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1em"
                                    viewBox="0 0 512 512"
                                    className="mr-1"
                                >
                                    <path
                                        d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"
                                        fill="currentColor"
                                    />
                                </svg>
                            ) : (
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="1em"
                                    viewBox="0 0 512 512"
                                    className="mr-1"
                                >
                                    <path
                                        d="M367.2 412.5L99.5 144.8C77.1 176.1 64 214.5 64 256c0 106 86 192 192 192c41.5 0 79.9-13.1 111.2-35.5zm45.3-45.3C434.9 335.9 448 297.5 448 256c0-106-86-192-192-192c-41.5 0-79.9 13.1-111.2 35.5L412.5 367.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"
                                        fill="currentColor"
                                    />
                                </svg>
                            )}

                            {!status ? "Publish" : "Unpublish"}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default PublishStatus;
